export default "__VITE_ASSET__xo0ujoxM__"